/**
 * Freie Tage (F-41) - rein und getestet: Wochenende, Feiertage des
 * Bundeslands und die Ferien aus den Schul-Einstellungen. An freien Tagen
 * koennen Benachrichtigungen zu einer anderen Zeit kommen oder ausbleiben.
 */
import { weekday } from '@/lib/datetime';
import { ferienAm } from '@/domain/school/ferien';
import type { Ferien, LocalDate } from '@/domain/types';

export type FreierTag = 'feiertag' | 'ferien' | 'wochenende';

/**
 * Warum der Tag frei ist - `null` = Werktag. Feiertag vor Ferien vor
 * Wochenende, damit der Anzeigetext das Besondere nennt. `feiertage` nimmt
 * ein Set oder die Map aus `holidayMap`.
 */
export function freierTagGrund(datum: LocalDate, ferien: readonly Ferien[], feiertage: { has(d: LocalDate): boolean }): FreierTag | null {
  if (feiertage.has(datum)) return 'feiertag';
  if (ferienAm(ferien, datum)) return 'ferien';
  const wt = weekday(datum);
  return wt === 0 || wt === 6 ? 'wochenende' : null;
}

export const istFreierTag = (datum: LocalDate, ferien: readonly Ferien[], feiertage: { has(d: LocalDate): boolean }): boolean =>
  freierTagGrund(datum, ferien, feiertage) !== null;
